import React from 'react';

import { BaseUploadFile } from 'components/wrappers/BaseFileUpload';
import adminApiClient from 'api/adminApiClient';
import { getFileUploadMessages } from 'utils/fileUtils';
import FormikFileUpload from 'components/formik/FormikFileUpload';
import backofficeApiClient, {
  ContractorCompanyTypeEnum,
} from 'api/backofficeApiClient';
import BaseDraggerContent from 'components/wrappers/BaseFileUpload/BaseDraggerContent';
import UploadList from 'components/wrappers/BaseFileUpload/UploadList';

const FILE_TYPES = ['DOC', 'DOCX', 'PDF', 'RTF'];
const fileUploadMessages = getFileUploadMessages({
  fileTypes: FILE_TYPES,
});

type Props = {
  fieldName: string;
  isAdmin: boolean;
  contractorCompanyFiles?: BaseUploadFile[];
  contractorCompanyType?: ContractorCompanyTypeEnum;
};

export default React.memo((props: Props) => {
  const {
    fieldName,
    contractorCompanyFiles = [],
    isAdmin,
    contractorCompanyType,
  } = props;

  const uploadWorkerFileLinkFunction = isAdmin
    ? adminApiClient.getWorkerFileUploadLink.bind(adminApiClient)
    : backofficeApiClient.getWorkerFileUploadLink.bind(backofficeApiClient);

  const uploadContractorCompanyFileLinkFunction = isAdmin
    ? adminApiClient.getContractorCompanyFileUploadLink.bind(adminApiClient)
    : backofficeApiClient.getContractorCompanyFileUploadLink.bind(
        backofficeApiClient,
      );

  const uploadFileLinkFunction =
    contractorCompanyType === ContractorCompanyTypeEnum.ParentSC
      ? uploadContractorCompanyFileLinkFunction
      : uploadWorkerFileLinkFunction;

  return (
    <FormikFileUpload
      name={fieldName}
      fileList={contractorCompanyFiles}
      isDraggable
      maxFileCount={1}
      acceptedFileSize={10}
      acceptedFileFormat={[
        '.doc',
        '.docx',
        '.pdf',
        '.rtf',
        'text/rtf',
        'application/msword',
        'application/pdf',
        'application/rtf',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      ]}
      getUploadList={UploadList}
      messages={fileUploadMessages}
      // onChange={handleFileChange}
      uploadLinkFunction={uploadFileLinkFunction}
    >
      {() => <BaseDraggerContent fileTypes={FILE_TYPES} />}
    </FormikFileUpload>
  );
});
